export default __webpack_public_path__ + "static/media/ic_tuongan.6b6859df.svg";